import React, { Component } from 'react';
import axios from 'axios';
import Auth from '../../../Auth';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import moment from 'moment';
import Header from './Header';
import Home from './Home';
import About from './About';
import HowTo from './HowTo';
import Shares from './Shares';
import QRLoader from './QRLoader';
import QR from './QR';
import ShowQR from './ShowQR';

class Dashboard extends Component {
    state = {
    	data: {
			user: {},
			group: {},
			school: {},
			project: {},
			settings: {
				been_payed: ''
			},
			sold_shares: null,
			group_sold_shares: null,
			group_toplist: [],
			country_toplist: []
		},
        errors: '',
        lightbox: false,
		loading: false,
		page: 'home',
		shares: 0,
		qr_loading: false,
		qr_image: null
    }

    constructor(props) {
        super(props);
        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

	componentWillMount() {
		document.getElementById('body').className='dark';
	}

	componentDidMount() {
        axios.get(API_URL+'/user/me')
            .then(response => {
                this.setState({
					data: response.data,
					loaded: true
                });
            })
            .catch(error => {
                this.setState({ errors: {1: 'Ett fel uppstod. Försök att logga ut och logga in på nytt.'} }, function() {
                    setTimeout(() => { Auth.logout() }, 3000);
                });
            });
    }

    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }

	/**
	 * Visa loader och invänta hämtning av QR-kod
	 */
	sellShares(shares) {
		this.setState({
			qr_loading: true,
			shares: shares
		});

		// Skapa förfrågan
		axios.post(API_URL+'/user/qr', {
				shares: shares,
				group_id: this.state.data.group.id,
				project_id: this.state.data.project.id
			})
			.then(response => {
				console.log('response', response);

				this.setState({
					qr_image: response.data,
					qr_loading: false,
					page: 'show_qr'
				});
			})
			.catch(error => {
				this.setState({ errors: {1: 'Ett fel uppstod. Var god försök igen.'} });
			});
	}

	cancelQRLoading() {
    	this.setState({
			qr_loading: false,
			page: 'home'
		});
	}

    render() {
        const { data } = this.state;
		const remaining_shares = (data.settings.shares - data.group_sold_shares) < 0 ? 0 : (data.settings.shares - data.group_sold_shares);
		const remaining_days = moment(data.settings.end_date).diff(moment(), 'days')+1 < 0 ? 0 : moment(data.settings.end_date).diff(moment(), 'days')+1;

		if (this.state.loading === false && !data.settings.been_payed) {
			return (
				<div>
					{ this.state.qr_loading &&
						<QRLoader parent={ this } />
					}

					<Errors errors={ this.state.errors } />

					<Header
						parent={ this }
						user={ data.user }
						group={ data.group }
						school={ data.school }
						project={ data.project }
					/>

					<div className="student-body">
						<div className="container">
							<div className="content">
								{ this.state.page === 'home' &&
									<Home
										parent={ this }
										project={ data.project }
										settings={ data.settings }
										remaining_shares={ remaining_shares }
										remaining_days={ remaining_days }
										sold_shares={ data.sold_shares }
										group_sold_shares={ data.group_sold_shares }
										toplist={ data.group_toplist }
										country_toplist={ data.country_toplist }
									/>
								}

								{ this.state.page === 'about' &&
									<About project={ data.project } parent={ this } />
								}

								{ this.state.page === 'how-to' &&
									<HowTo parent={ this } />
								}

								{ this.state.page === 'shares' &&
									<Shares
										parent={ this }
										settings={ data.settings }
									/>
								}

								{ this.state.page === 'qr' &&
									<QR
										parent={ this }
										settings={ data.settings }
										shares={ this.state.shares }
									/>
								}

								{ this.state.page === 'show_qr' &&
									<ShowQR parent={ this }	/>
								}
							</div>
						</div>
					</div>
				</div>
			)
		} else if (this.state.loading === true) {
			return false;
		} else {
			Auth.logout();
		}
	}
}
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/index.js